import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class NewsService {
    private newsAPI = '../assets/json/news.json';
    private photoAPI = '../assets/json/images.json';
    private photoAPINEW = '../assets/json/images_new.json';
    private photoAPINews = '../assets/json/newsImages.json';

  constructor(private httpClient: HttpClient,
  ) { }

  photoData(): Observable<any> {
    const timestamp = new Date().getTime();
      return this.httpClient.get(this.photoAPI + '?t=' + timestamp);
      //return this.http.get(this.photoAPINEW);
  }
  photoContent(): Observable<any> {
      const timestamp = new Date().getTime();
      return this.httpClient.get(this.photoAPI + '?t=' + timestamp);
  }

  newsData(): Observable<any> {
    const timestamp = new Date().getTime();
    return this.httpClient.get(this.newsAPI + '?t=' + timestamp);

/*
      return this.http.get(this.newsAPI).subscribe(data => {
          console.log('JSON File Loaded', data.json().slice(0));
          return data.json().slice(0);
      });
      */
  }
  getImages(): Observable<any> {
      const timestamp = new Date().getTime();
      return this.httpClient.get(this.photoAPINews + '?t=' + timestamp);
  }
}
